import { z } from "zod/mini"

const EmbedShape = {
	embed_url: z.string(),
	type: z.string(),
	version: z.nullish(z.union([z.string(), z.number()])),
	title: z.nullish(z.string()),
	author_name: z.nullish(z.string()),
	author_url: z.nullish(z.string()),
	provider_name: z.nullish(z.string()),
	provider_url: z.nullish(z.string()),
	cache_age: z.nullish(z.union([z.string(), z.number()])),
	thumbnail_url: z.nullish(z.string()),
	thumbnail_width: z.nullish(z.number()),
	thumbnail_height: z.nullish(z.number()),
	html: z.nullish(z.string()),
}

export const EmbedLegacySchema = z.object(EmbedShape)

export const EmbedLegacyLooseSchema = z.looseObject(EmbedShape)

export type EmbedLegacy = z.infer<typeof EmbedLegacySchema>
